import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'db0009',
    ecrans: ['00-2'],
    params: ['id', '?pbpcleint', '?prucleint']
});
